<template>
  <el-table
    :data="countTable"
    :span-method="objectSpanMethod"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column prop="platformName" label="平台" align="center" />
    <el-table-column prop="sellerName" label="店铺名称" align="center" />
    <el-table-column prop="introduceCount" label="引入期客户" align="center" />
    <el-table-column prop="longTermCount" label="成长期客户" align="center" />
    <el-table-column prop="matureCount" label="成熟期客户" align="center" />
    <el-table-column prop="declineCount" label="衰退期客户" align="center" />
    <el-table-column prop="lossCount" label="流失期客户" align="center" />
    <el-table-column prop="totalCount" label="全部客户" align="center" />
  </el-table>
</template>

<script>
import mixins from "../../mixins/index.js";
import Empty from "../../components/empty.vue";
export default {
  mixins: [mixins],
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
  },
  computed: {
    countTable() {
      return this.tableData;
    },
  },

  methods: {
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      const isSameLabelRow =
        row.platformName &&
        row.sellerName &&
        row.platformName === row.sellerName;

      if (isSameLabelRow) {
        if (columnIndex === 0) {
          return {
            rowspan: 1,
            colspan: 2,
          };
        }
        if (columnIndex === 1) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }

      if (columnIndex === 0) {
        const current = row.platformName;
        const prev = this.countTable[rowIndex - 1]?.platformName;
        if (current && current === prev) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.countTable.length; i++) {
          if (this.countTable[i]?.platformName === current) {
            rowspan++;
          } else {
            break;
          }
        }
        return {
          rowspan,
          colspan: 1,
        };
      }
    },
  },
};
</script>
